import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { error } from 'react-notification-system-redux';
import { notificationsConfig } from '../../config/constants';
import { subDays, startOfDay, isAfter, parseISO, isBefore } from 'date-fns';
import { useDashboardAPI } from '../../hooks';
export const useTaskQuery = () => {
    const dispatch = useDispatch();
    const api = useDashboardAPI();
    return useQuery({
        queryKey: ['lastTask'],
        queryFn: () => api.field.getLastTask(),
        select: (data) => {
            return data;
        },
        onError: (err) => {
            dispatch(error({
                ...notificationsConfig.defaultConf,
                translationKey: 'widget::cant_load_task',
            }));
        },
    });
};
export const useTaskCountByDate = (variables) => {
    const dispatch = useDispatch();
    const api = useDashboardAPI();
    return useQuery({
        queryKey: ['countTaskByDate'],
        queryFn: () => api.field.getTaskCountByDate(variables.fromDate),
        select: ({ data, totalCount }) => {
            const today = startOfDay(new Date());
            const yesterday = subDays(today, 1);
            return {
                weekCount: totalCount,
                todayCount: data.filter((item) => isAfter(parseISO(item.startDate), today)).length,
                yesterdayCount: data.filter((item) => (isAfter(parseISO(item.startDate), yesterday) && isBefore(parseISO(item.startDate), today))).length,
            };
        },
        onError: (err) => {
            dispatch(error({
                ...notificationsConfig.defaultConf,
                translationKey: 'widget::cant_load_task',
            }));
        },
    });
};
//# sourceMappingURL=useTaskQuery.js.map